import {ComponentRef, Injectable, Injector} from '@angular/core';
import {Overlay, OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {FrontendLoadingComponent} from "../../module/frontend-loading/frontend-loading.component";

export class LoadingOverlayRef {
  constructor(private overlayRef: OverlayRef) {
  }

  close(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
}

@Injectable()
export class LoadingService {
  constructor(private injector: Injector, private overlay: Overlay) {
  }

  open(): LoadingOverlayRef {
    try {
      const overlayRef = this.createOverlay();
      const dialogRef = new LoadingOverlayRef(overlayRef);
      const overlayComponent = this.attachDialogContainer(overlayRef, dialogRef);
      return dialogRef;
    } catch (error) {
      return new LoadingOverlayRef(null as any);
    }
  }

  private createOverlay(): OverlayRef {
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();
    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy
    });
    return this.overlay.create(overlayConfig);
  }

  private attachDialogContainer(overlayRef: OverlayRef, dialogRef: LoadingOverlayRef): FrontendLoadingComponent {
    const injector = this.createInjector(dialogRef);
    const containerPortal = new ComponentPortal(FrontendLoadingComponent, null, injector);
    const containerRef: ComponentRef<FrontendLoadingComponent> = overlayRef.attach(containerPortal);
    return containerRef.instance;
  }

  private createInjector(dialogRef: LoadingOverlayRef): Injector {
    const injectionTokens = new WeakMap();
    injectionTokens.set(LoadingOverlayRef, dialogRef);
    return Injector.create({
      providers: [
        {
          provide: LoadingOverlayRef,
          useValue: dialogRef
        }
      ],
      parent: this.injector
    });
  }
}
